export function SeoJsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function ArticleJsonLd({
  url,
  headline,
  description,
  imageUrl,
  datePublished,
  dateModified,
  authorName,
}: {
  url: string;
  headline: string;
  description: string;
  imageUrl: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
}) {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.sbs';

  const articleData = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline,
    description,
    image: imageUrl,
    datePublished,
    dateModified,
    author: {
      '@type': 'Organization',
      name: authorName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Kakobuy Polska Spreadsheet Guide',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    inLanguage: 'pl-PL',
  };

  return <SeoJsonLd data={articleData} />;
}

export function WebSiteJsonLd() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.sbs';

  const data = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Polska Spreadsheet Guide',
    url: siteUrl,
    description: 'Niezależny polski przewodnik po Kakobuy Spreadsheet – tutoriale, listy produktów, porównania i poradniki bezpieczeństwa.',
    inLanguage: 'pl-PL',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return <SeoJsonLd data={data} />;
}

export function FaqJsonLd({ faqs }: { faqs: Array<{ q: string; a: string }> }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return <SeoJsonLd data={data} />;
}